<template>
    <div class="rest_list__product" :class="classItem">
        <div class="rest_list__product_info cursor_pointer" @click.prevent="clickInfo">
            <checkbox_custom
                :key="'checkbox_custom_' + itemId"
                :checkboxState="prodItem.isCheck"
            />
            <div class="rest_list__product_info_img">
                <picture>
                    <source :srcset="imageWebp" type="image/webp">
                    <source :srcset="imagePng" type="image/png">
                    <img :src="imagePng">
                </picture>
            </div>
            <div v-if="isStopListItem" class="rest_list__product_info_title">
                {{ titleProduct }}
            </div>
            <div v-else class="rest_list__product_info_title">
                <div class="rest_list__product_info_title_block">
                    <div class="rest_list__product_info_title_block_product">
                        {{ titleProduct }}
                    </div>
                    <div class="rest_list__product_info_title_block_category">
                        {{ titleCategory }}
                    </div>
                </div>
            </div>
            <div v-if="isStopListItem" class="rest_list__product_info_icon">
                <svg height="24" width="24">
                    <use xlink:href="/icons/base.svg#stop_list_product"></use>
                </svg>
            </div>
        </div>
        <div v-if="isStopListItem" class="rest_list__product_img_menu cursor_pointer"
             @click.prevent="openModalProductLocations">
            <svg>
                <use xlink:href="/icons/base.svg#icon_list_product_stop"></use>
            </svg>
        </div>
        <div v-else class="rest_list__product_price">
            {{ priceProduct }}
        </div>
    </div>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import checkbox_custom from "../../../CheckboxCustom.vue";
import {colorFunctions} from "../../../../mixins/colorFunctions";
import getObjectPathProperty from "../../../../mixins/getObjectPathProperty";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "rest_list_item_product",
    props: {
        prodItem: {
            type: Object,
            required: true,
        },
        isStopListItem: {
            type: Boolean,
            required: true,
        }
    },
    emits: ['open_modal_product_locations'],
    components: {checkbox_custom},
    mixins: [colorFunctions],
    methods: {
        clickCheckboxCustom() {
            this.prodItem.isCheck = !this.prodItem.isCheck;
        },
        clickInfo() {
            this.clickCheckboxCustom();
        },
        openModalProductLocations() {
            this.$emit('open_modal_product_locations', this.prodItem);
        }
    },
    computed: {
        ...mUser([
            'user',
        ]),
        currencyUser() {
            if (this.user && this.user.currency_suffix) {
                return this.user.currency_suffix;
            }
            return '';
        },
        titleProduct() {
            if (this.getObjectPathProperty(this.prodItem, 'product.title')) {
                return this.prodItem.product.title;
            }
            return 'no title';
        },
        titleCategory() {
            if (this.getObjectPathProperty(this.prodItem, 'main_category.title')) {
                return this.prodItem.main_category.title;
            }
            return 'no title category';
        },
        priceProduct() {
            if (this.prodItem.price) {
                return this.prodItem.price + ' ' + this.currencyUser;
            }
            return '';
        },
        classItem() {
            if (this.isStopListItem) {
                return {'stop_list': true};
            }
            return {'stop_list': false};
        },
        itemId() {
            if (this.prodItem && this.prodItem.id) {
                return this.prodItem.id;
            }
            return '';
        },
        imageWebp() {
            if (this.prodItem.image && this.prodItem.image.webp) {
                return this.prodItem.image.webp;
            }
            return '';
        },
        imagePng() {
            if (this.prodItem.image && this.prodItem.image.png) {
                return this.prodItem.image.png;
            }
            return '';
        }
    }
}
</script>
